import React, { useState } from "react";
import styled from "styled-components";
// import { Button, Flex } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { colors } from "../../../../styles/theme";

const SidebarLink = styled.button`
	display: flex;
	color: black;
	justify-content: space-between;
	align-items: center;
	list-style: none;
	text-decoration: none;
	font-size: 1rem;
	border-block: 0.00001px solid #ccc;
	padding-block: 0.8rem;

	:first-of-type {
	}

	&:hover {
		cursor: pointer;
		color: ${colors.primaryColor};
		svg {
			color: ${colors.primaryColor};
		}
	}
`;

const SidebarLabel = styled.span`
	margin-left: 10px;
`;

const DropdownLink = styled.button`
	background: white;
	padding-left: 3rem;
	display: flex;
	align-items: center;
	text-decoration: none;
	color: black;
	font-size: 15px;
	margin-block: 1rem;

	&:hover {
		cursor: pointer;
	}
`;

const FlexBox = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const SubMenu = ({ item, toggleSideBar }) => {
	const [subnav, setSubnav] = useState(false);

	const showSubnav = () => setSubnav(!subnav);

	const handleClick = () => {
		if (item.subNav) {
			showSubnav();
		}
		if (!item.subNav) {
			toggleSideBar();
		}
	};
	return (
		<>
			<SidebarLink
				href={item.subNav ? "/" : item.path}
				onClick={handleClick}
				as={Link}
				iconspacing={"1rem"}
			>
				<FlexBox>
					{item.icon}
					<SidebarLabel>{item.title}</SidebarLabel>
				</FlexBox>
				<div>
					{item.subNav && subnav
						? item.iconOpened
						: item.subNav
							? item.iconClosed
							: null}
				</div>
			</SidebarLink>

			{subnav &&
				item.subNav.map((item, index) => {
					return (
						<DropdownLink
							href={item.path}
							key={index}
							onClick={() => {
								toggleSideBar();
							}}
							as={Link}
						>
							{item.icon}
							<SidebarLabel>{item.title}</SidebarLabel>
						</DropdownLink>
					);
				})}
		</>
	);
};

export default SubMenu;